// src/components/testimonials/VideoTestimonials.js
import React, { useRef, useState } from 'react';
import video1 from '../../Assets/videos/VideoTestimonial1.mp4'
import video2 from '../../Assets/videos/VideoTestimonial2.mp4'
import video3 from '../../Assets/videos/VideoTestimonial3.mp4'

const videoTestimonials = [
  { id: 1, name: "Philip, America", role: "Dental surgery", quote: "From fear to confidence in just one day – thank you team!", videoSrc: video1 },
  { id: 2, name: "John Lesley, England", role: "Bridges and Crowns", quote: "I never thought my smile could look this natural again!", videoSrc: video2 },
  { id: 3, name: "Paul Disher, Australia", role: "Implants", quote: "Painless treatment and excellent follow-up care.", videoSrc: video3 },
];

const VideoTestimonials = () => {
  const [hoveredId, setHoveredId] = useState(null);
  const [isAudioBlocked, setIsAudioBlocked] = useState(false);
  const videoRefs = useRef({});

  const handleMouseEnter = async (videoId) => {
    setHoveredId(videoId);
    const videoEl = videoRefs.current[videoId];
    if (videoEl) {
      videoEl.muted = false; // Force unmute on hover
      
      try {
        await videoEl.play();
        setIsAudioBlocked(false); // If play succeeds, audio is not blocked
      } catch (err) {
        // If browser blocks unmuted play, play it muted so it still moves
        console.warn("Browser blocked unmuted autoplay. User must click first.");
        videoEl.muted = true;
        videoEl.play();
        setIsAudioBlocked(true); // Show the "Click for sound" hint
      }
    }
  };

  const handleMouseLeave = (videoId) => {
    setHoveredId(null);
    const videoEl = videoRefs.current[videoId];
    if (videoEl) {
      videoEl.pause();
      videoEl.currentTime = 0;
    }
  };

  // This function "unlocks" the audio for the whole page
  const unlockAudio = (videoId) => {
    const videoEl = videoRefs.current[videoId];
    if (videoEl) {
      videoEl.muted = false;
      videoEl.play();
      setIsAudioBlocked(false);
    }
  };

  return (
    <div className="mt-16 mb-20">
      <h3 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-10">
        Real Voices, Real Smiles
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 px-4 md:px-0">
        {videoTestimonials.map((video) => {
          const isHovered = hoveredId === video.id;

          return (
            <div
              key={video.id}
              className="group relative rounded-2xl overflow-hidden shadow-lg transition-all duration-500 hover:shadow-2xl hover:-translate-y-2 border border-gray-200 bg-white cursor-pointer"
              onMouseEnter={() => handleMouseEnter(video.id)}
              onMouseLeave={() => handleMouseLeave(video.id)}
              onClick={() => unlockAudio(video.id)}
            >
              <div className="relative aspect-video bg-black">
                <video
                  ref={(el) => { if (el) videoRefs.current[video.id] = el; }}
                  src={video.videoSrc}
                  className="w-full h-full object-cover"
                  loop
                  playsInline
                  muted // Default must be muted for browsers to allow the initial play
                />

                {/* Show "Tap for Sound" if browser blocks hover-audio */}
                {isHovered && isAudioBlocked && (
                  <div className="absolute top-4 right-4 bg-black/60 text-white text-[10px] px-2 py-1 rounded-full animate-pulse flex items-center gap-1">
                    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15.536 8.464a5 5 0 010 7.072m2.828-9.9a9 9 0 010 12.728M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z" /></svg>
                    TAP FOR SOUND
                  </div>
                )}

                {/* Overlay when NOT hovered */}
                {!isHovered && (
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent flex flex-col justify-end p-6">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-blue-600 flex items-center justify-center text-white font-bold text-lg">
                        {video.name[0]}
                      </div>
                      <div>
                        <h4 className="font-semibold text-white text-lg">{video.name}</h4>
                        <p className="text-blue-200 text-sm">{video.role}</p>
                      </div>
                    </div>
                    <p className="text-white text-sm mt-3 italic line-clamp-2">"{video.quote}"</p>
                  </div>
                )}

                {/* Play icon when not hovered */}
                {!isHovered && (
                  <div className="absolute inset-0 flex items-center justify-center ml-[70%] mb-[30%]">
                    <div className="w-12 h-12 rounded-full bg-blue-600/90 flex items-center justify-center shadow-lg transform group-hover:scale-110 transition-transform">
                      <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M8 5v14l11-7z" />
                      </svg>
                    </div>
                  </div>
                )}
              </div>

              {/* Mobile Info */}
              <div className="p-5 md:hidden bg-white">
                <h4 className="font-semibold text-gray-900">{video.name}</h4>
                <p className="text-sm text-gray-600">{video.role}</p>
              </div>
            </div>
          );
        })}
      </div>

      <div className="text-center mt-10">
        <p className="text-gray-600 italic">
          Hover to play. If silent, click once to enable audio.
        </p>
      </div>
    </div>
  );
};

export default VideoTestimonials;